<template>
    <div class="w-full max-w-30rem mb-6">
        <span class="H6-Medium block text-center">You're downgrading to {{ targetPackage?.name || 'Foundation' }}</span>
        <span class="Label block text-center mt-1 mb-6">Review the details of your plan downgrade</span> 

        <div class="w-full flex justify-content-between mb-3">
            <span class="Label">Your current plan</span>
            <span class="font-semibold Label">{{ currentPlanName }}</span>
        </div>
        <div class="w-full flex justify-content-between mb-4">
            <span class="Label">Your new plan</span>
            <span class="font-semibold Label">{{ targetPackage?.name || 'Foundation' }}</span>
        </div>

        <hr class="border-top-1 border-none border-gray-200 mb-4" style="width: 120%; margin-left: -10%;" />

        <div class="w-full flex justify-content-between mb-3">
            <span class="Label">New price</span>
            <span class="font-semibold Label">Rs. {{ targetPackage?.priceLabel || '0' }}</span>
        </div>

        <hr class="w-full border-top-1 border-none border-gray-200 mb-4" />

        <div class="w-full flex justify-content-between mb-3">
            <span class="Label">Effective date</span>
            <span class="font-semibold Label">{{ nextBillingDate }}</span>
        </div>
        <div class="w-full flex justify-content-between mb-6">
            <span class="Label">Billing cycle</span>
            <span class="font-semibold Label">Monthly</span>
        </div>

        <div class="w-full flex flex-column px-6 py-2">
            <Button label="Confirm downgrade" class="w-full orange-button mb-3" :loading="loading" :disabled="loading" @click="$emit('confirm')" />
            <Button label="Keep current plan" class="w-full p-button-outlined p-button-secondary" :disabled="loading" @click="$emit('cancel')" />
        </div>

        <p class="Label text-xs mt-6 text-center">You can upgrade your plan to {{ currentPlanName }} again at any time</p>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import Button from 'primevue/button';

defineProps({
    currentPlanName: String,
    targetPackage: Object,
    nextBillingDate: String,
    loading: { type: Boolean, default: false }
});

defineEmits(['confirm', 'cancel']);
</script>

<style scoped>
.p-button-outlined {
    background-color: var(--accent-50) !important;
    font-weight: 600;
    color: black !important;
}

.p-button-outlined:not(:disabled):hover {
    background-color: var(--accent-100) !important;
}
</style>